var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45125 1.14632e-05C7.10351 0.000126279 5.77533 0.32253 4.57753 0.940325C3.37973 1.55812 2.34704 2.45339 1.56563 3.55145C0.78421 4.6495 0.276726 5.9185 0.0855107 7.25256C-0.105704 8.58662 0.0248963 9.94707 0.466416 11.2204C0.907935 12.4937 1.64757 13.643 2.62361 14.5724C3.59966 15.5017 4.7838 16.1842 6.07726 16.5628C7.37072 16.9415 8.73598 17.0054 10.0591 16.7491C11.3823 16.4928 12.625 15.9239 13.6835 15.0897L20.1061 21.5121C20.2936 21.6932 20.5448 21.7935 20.8055 21.7912C21.0662 21.7889 21.3156 21.6844 21.5 21.5C21.6844 21.3157 21.7889 21.0663 21.7912 20.8056C21.7935 20.5449 21.6932 20.2937 21.5121 20.1062L15.0895 13.6837C16.0719 12.4375 16.6836 10.9398 16.8546 9.36217C17.0256 7.78452 16.7489 6.19061 16.0563 4.76285C15.3636 3.3351 14.283 2.13117 12.9381 1.28887C11.5931 0.446563 10.0382 -9.50897e-05 8.45125 1.14632e-05ZM1.98799 8.45165C1.98799 6.73755 2.66894 5.09366 3.88104 3.88161C5.09313 2.66956 6.73709 1.98863 8.45125 1.98863C10.1654 1.98863 11.8094 2.66956 13.0215 3.88161C14.2336 5.09366 14.9145 6.73755 14.9145 8.45165C14.9145 10.1658 14.2336 11.8096 13.0215 13.0217C11.8094 14.2338 10.1654 14.9147 8.45125 14.9147C6.73709 14.9147 5.09313 14.2338 3.88104 13.0217C2.66894 11.8096 1.98799 10.1658 1.98799 8.45165Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.ec128ed219962e4cb02f9b6ea83888d2.svg";
export { ForwardRef as ReactComponent };